(function ($) {
  Drupal.behaviors.emailValidation = {
    attach: function (context, settings) {
      let emailInput = document.querySelector(
        ".data-update-form .js-form-type-email input"
      );

      let phoneInput = document.querySelector(
        ".data-update-form  .js-form-item-cellphone-number input"
      );

      //jv change
      if (emailInput !== null) {
        emailInput.setAttribute("maxLength", "70");
      }

      if (emailInput != null) {
        let btnContinuar = document.querySelector(
          ".form-actions.btn-siguiente input"
        );

        function emailReg(email) {
          const isEmailValid = $(emailInput).valid();
          const hasValidSuffix = /\.([a-z]{2,})+$/.test(email);
          let isEmail = false;

          if (isEmailValid && hasValidSuffix) {
            isEmail = true;
          }

          if (!isEmail) {
            emailInput.classList.add("is-invalid");
            emailInput.parentElement.classList.remove("fixed");
          } else {
            emailInput.classList.remove("is-invalid");
            emailInput.parentElement.classList.add("fixed");
          }
          if (emailInput.value == "") {
            emailInput.classList.remove("is-invalid");
            emailInput.parentElement.classList.add("fixed");
          }
        }

        emailInput.addEventListener("keyup", () => {
          emailReg(emailInput.value);
        });
      }
    },
  };
})(jQuery);
